module.exports = __webpack_public_path__ + "img/invatatura-bisericeasca-1774-pagina-de-titlu-big.82f99028.jpg";